import { Component, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import { VendorService } from 'src/app/services/vendor.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { VendorActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/vendor-action-items.component';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { VendorConfigComponent } from '../vendor-config/vendor-config.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-listvendor',
  templateUrl: './listvendor.component.html',
  styleUrls: ['./listvendor.component.scss']
})
export class ListVendorComponent implements OnInit, OnDestroy {
  vendorList = [];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isActionAllowed = true;

  public isCollapsed = true;
  enabled: boolean;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: "autoHeight"
  }
  columnDefs = [
    { headerName: 'Code', field: 'code', filter: true },
    { headerName: 'Name', field: 'name', filter: true },
    { headerName: 'Vendor Mode', field: 'vendormode' },
    { 
      headerName: 'API Enabled', 
      field: 'apienabled',
      cellRenderer : (params : {value:boolean})=>{
        let statusHtml = '<span class="badge  bg-warning">No</span>';
        if(params.value){
          statusHtml = '<span class="badge bg-success">Yes</span>';
        }
        return statusHtml;
       } 
      },
    {
       headerName: 'Status', 
       field: 'isactive',
       cellRenderer : (params : {value:boolean})=>{
        let statusHtml = '<span class="badge bg-dark">Not Active</span>';
        if(params.value){
          statusHtml = '<span class="badge bg-success">Active</span>';
        }
        return statusHtml;
       } 
      },
    {
      headerName: 'Actions',
      field: 'id',
      // cellRendererParams: { context: this },
      cellRenderer: VendorActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];
  rowData = [];

  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private vendorService: VendorService,
    private modalService: NgbModal,
    private titleService: Title
  ) {
    titleService.setTitle('Vendors');
    this.context = { componentParent: this };
  }

  ngOnInit() {
    this.checkPermission();
    // this.renderData();
    if (this.permConfig.isViewAllowed) {
      this.bindVendorList();
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Vendors');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindVendorList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.vendorService.GetAllList({ refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          // console.log(res);
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  ngOnDestroy(): void {
  }

  onGridReady(params: GridReadyEvent, enabled?: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // console.log('params.columnApi;', params.context.componentParent);
    params.api.sizeColumnsToFit();
  }

  addServiceAction(cell: any) {
    // console.log(cell);
    if (!this.permConfig.isEditAllowed) {
      this.warningDialog('No access to Edit.');
    }
    else if (this.permConfig.isEditAllowed && cell && cell.id) {
      const serviceURL = `/setup/vendors/${cell.id}/services`;
      this.router.navigate([serviceURL]);
    }

  }

  AccountManagementPageAction(cell: any) {
    // console.log(cell);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate([`/setup/vendors/${cell.id}/accountmanagement`]);
      }
    } catch (e) {
      console.error(e);
    }
  }

  APIConfigurationPageAction(cell: any) {
    // console.log(cell);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate([`/setup/vendors/${cell.id}/apiconfiguration`]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  editAction(cell: any) {
    // console.log(cell);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/setup/vendors/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  deleteAction(cell: any) {
    //  console.log('cell');
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }

  }

  deleteService(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.vendorService.Delete(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.bindVendorList(true);
            this.appCoreService.showMessage('Record Deleted Successfully !','Success','success')
          }else if(res && !res.success){
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message,'Cannot delete !','error')
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  vendorServiceConfig() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };

    const modalRef = this.modalService.open(VendorConfigComponent, ngbModalOptions);
    modalRef.componentInstance.vendorType = 'VENDOR';
    modalRef.result.then(
      (result) => {
        if (result) {
          // console.log('Closed with: result', result);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason == 'Cross click') {
        }
      }
    );
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteService(id);

    }
  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }
}
